import React, { useEffect, useState } from "react";
import { BellRing, X, Loader2 } from "lucide-react";
import { toast } from "react-toastify";

import { Button } from "../ui/button";
import { pushSuportado, statusPush, ativarPush } from "../../push/pushNativo";

// Aviso global para ligar o push nativo. Aparece para QUALQUER usuario (nao só
// admin) quando o aparelho ainda nao assinou — a tela de Configuracoes é so de
// admin e no celular fica escondida, e o atendente é justamente quem precisa
// do aviso de mensagem nova. O toque no botao satisfaz a exigencia do iOS de
// que a permissao venha de um gesto do usuario.

const CHAVE_DISPENSADO = "push_prompt_dispensado";

const NotificacoesPrompt = () => {
	const [mostrar, setMostrar] = useState(false);
	const [ocupado, setOcupado] = useState(false);

	useEffect(() => {
		let vivo = true;
		(async () => {
			if (!pushSuportado()) return;
			let dispensado = false;
			try {
				dispensado = localStorage.getItem(CHAVE_DISPENSADO) === "1";
			} catch {
				/* sem storage: mostra mesmo assim */
			}
			if (dispensado) return;
			const st = await statusPush();
			if (vivo && st === "inativo") setMostrar(true);
		})();
		return () => {
			vivo = false;
		};
	}, []);

	const ativar = async () => {
		setOcupado(true);
		try {
			await ativarPush();
			toast.success("Notificacoes ativadas neste aparelho.");
			setMostrar(false);
		} catch (e) {
			toast.error(e?.message || "Nao foi possivel ativar.");
		}
		setOcupado(false);
	};

	const dispensar = () => {
		try {
			localStorage.setItem(CHAVE_DISPENSADO, "1");
		} catch {
			/* sem storage: some so nesta sessao */
		}
		setMostrar(false);
	};

	if (!mostrar) return null;

	return (
		<div className="fixed inset-x-3 top-[calc(0.75rem+env(safe-area-inset-top))] z-50 mx-auto flex max-w-md items-center gap-3 rounded-xl border bg-card p-3 shadow-lg">
			<div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary">
				<BellRing className="h-4 w-4" />
			</div>
			<div className="min-w-0 flex-1">
				<p className="text-sm font-medium">Ativar notificacoes</p>
				<p className="text-xs text-muted-foreground">
					Receba aviso de mensagem nova mesmo com o app fechado.
				</p>
			</div>
			<Button
				size="sm"
				className="h-8 shrink-0"
				onClick={ativar}
				disabled={ocupado}
			>
				{ocupado ? <Loader2 className="h-4 w-4 animate-spin" /> : "Ativar"}
			</Button>
			<button
				type="button"
				onClick={dispensar}
				aria-label="Dispensar"
				className="shrink-0 text-muted-foreground hover:text-foreground"
			>
				<X className="h-4 w-4" />
			</button>
		</div>
	);
};

export default NotificacoesPrompt;
